export default {
    cptDataForm:{
        dataSource: 1, pollTime: 0,
        dataText: '{"value":22}',
    },
    attribute:{
        title:'速度',min:0,max:100,lineDistance:5,labelDistance:10,labelSize:12,tickLength:5,
        pointerLength:75,pointerWidth:6,detailSize:25,detailColor:'#ddd',titleSize:12,titleColor:'#ddd',
        lineWidth:3,color1:'#67e0e3',color2:'#37a2da',color3:'#fd666d',itemColor:'#6ADA13',
        startAngle:225,endAngle:-45
    }
}
